import Component from '../../shared/component';

export default class StarRating extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.$stars = this.$element.find('.starRating-image');
    this.$ratingField = this.$element.find('.starRating-value');
    this.$defaultRatingField = this.$element.find('.starRating-defaultValue');

    this.fullStarImageUrl = this.$element.data('full-star-image-url');
    this.emptyStarImageUrl = this.$element.data('empty-star-image-url');

    this.selectedStar = null;

    this.bindEvents();

    this.handleDefaultValueIfSpecified();

    if (this.$ratingField.val()) this.selectStar(this.$ratingField.val());
  }

  bindEvents() {
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleStarClick = this.handleStarClick.bind(this);

    this.bindStarRatingEvents();
  }

  unbindEvents() {
    this.unbindStarRatingEvents();
  }

  handleMouseEnter(event) {
    const $currentStar = $(event.target);

    this.highlightStars($currentStar);
  }

  handleMouseLeave() {
    this.resetStars();
  }

  handleStarClick(event) {
    const $currentStar = $(event.target);

    this.highlightStars($currentStar);
    this.selectStar($currentStar.data('rating'));
  }

  resetStars(force = false) {
    if (force || !this.selectedStar) {
      this.$stars.attr('src', this.emptyStarImageUrl);
    } else {
      this.selectedStar.attr('src', this.fullStarImageUrl);
      this.selectedStar
        .prevAll('.starRating-image')
        .attr('src', this.fullStarImageUrl);
      this.selectedStar
        .nextAll('.starRating-image')
        .attr('src', this.emptyStarImageUrl);
    }
  }

  unbindStarRatingEvents() {
    this.$element.off('mouseleave.StarRating', this.handleMouseLeave);
    this.$stars.off('mouseenter.StarRating', this.handleMouseEnter);
    this.$stars.off('click.StarRating', this.handleStarClick);
  }

  bindStarRatingEvents() {
    this.$element.on('mouseleave.StarRating', this.handleMouseLeave);
    this.$stars.on('mouseenter.StarRating', this.handleMouseEnter);
    this.$stars.on('click.StarRating', this.handleStarClick);
  }

  highlightStars($currentStar) {
    this.resetStars(true);

    $currentStar.attr('src', this.fullStarImageUrl);
    $currentStar
      .prevAll('.starRating-image')
      .attr('src', this.fullStarImageUrl);
  }

  selectStar(rating) {
    this.$ratingField.val(rating);
    this.selectedStar = this.$element.find(
      `.starRating-image[data-rating=${rating}]`
    );

    this.resetStars();
  }

  handleDefaultValueIfSpecified() {
    if (this.$defaultRatingField.val()) {
      this.selectStar(this.$defaultRatingField.val());
      this.unbindStarRatingEvents();
    }
  }
}
